import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";


    export class ChickenWaiting extends Phaser.Sprite {

        public pulsing: boolean;
        public pecking: boolean;

        private animIdle: Phaser.Animation;
        private animPeck: Phaser.Animation;

        private side: string;
        private f: number;
        private isIdle: boolean;

        constructor(game: Phaser.Game, x: number, y: number, side: string) {

            super(game, x, y, "texture_atlas_1", "chicken_idle_0001.png");

            this.side = side;
            this.pecking = false;
            this.pulsing = false;
            this.f = 0;
            this.isIdle = Math.random() > .6;

            this.animIdle = this.animations.add("idle", Phaser.Animation.generateFrameNames("chicken_idle_", 1, 16, ".png", 4));
            this.animPeck = this.animations.add("peck", Phaser.Animation.generateFrameNames("chicken_idle2_", 1, 14, ".png", 4));
            this.animPeck.onComplete.add(function(): void {
                this.pecking = false;
                if (this.isIdle) {
                    let frameRate = GameVars.randomDataGenerator.realInRange(10, 20);
                    this.play("idle", frameRate, true);
                    this.changeFrameRate(frameRate);
                } else {
                    this.frameName = "chicken_idle_0001.png";
                }
            }, this);

            this.anchor.set(.5, 1);

            if (this.isIdle) {
                let frameRate = GameVars.randomDataGenerator.realInRange(10, 20);
                this.play("idle", frameRate, true);
                this.changeFrameRate(frameRate);
            }

            if (this.side === GameConstants.LEFT && Math.random() > .7) {
                this.scale.x = -1;
            }
        }
        
        public pulse(): void {
            
            this.pulsing = true;

            this.game.add.tween(this.scale)
                .to({ x: this.scale.x * 1.025 , y: .975}, 1000, Phaser.Easing.Linear.None, true, 0, 0, true)
                .onComplete.add(function(): void {
                    this.pulsing = false;
                }, this);
        }

        public peck(): void {
            
            this.pecking = true;

            const frameRate = GameVars.randomDataGenerator.realInRange(20, 26);

            this.play("peck", frameRate);
            this.changeFrameRate(frameRate);

            if (Math.random() > .65) {
                this.scale.x *= -1;
            }
        }

        public changeFrameRate(frameRate: number): void {

            let speedFreeze = GameVars.freezeAction ? .15 : 1;

            this.animIdle.speed = frameRate * speedFreeze;
            this.animPeck.speed = frameRate * speedFreeze;
        }
    }
